module.exports = __webpack_public_path__ + "img/company_logo.827855a8.png";